












































































  import { Component, Vue, Watch, Prop, Emit } from 'vue-property-decorator';
  // import * as url from 'url';
  const url = require('url')
  import { first, sample, throttle, padStart, noop, find } from 'lodash-es';
  import { autobind } from 'core-decorators';
  import qs from 'qs';
  import BackDrop from '../../../../component-dev/backdrop';
  import Dialog from '../../../../component-dev/dialog';
  import Button from '../../../../component-dev/button';
  import config from '../../config.json';
  import QRCode from '../../../../component-dev/qrcode';
  import { IS_ANDROID, IS_MQQ, IS_ZXG } from '../../../../service/platform/environment';
  import { sdk } from '../../../../service/platform';
  import { activity } from '../../../../service/activity';
  import { user, UserState } from '../../../../service/user';
  import { hasAccount, isSubscribe, userHasState } from '../../../../service/activity/RuleSet';
  import { makeStatReportParam } from '../../../../service/stat/Directive';
  import { stat } from '../../../../service/stat';
  import longTouch from '../../directive/longTouch';
	// 大吉大利按钮的跳转链接
  const links = {
    wzqIndex: 'https://wzq.tenpay.com/mp/v1/choose/list.shtml',
    wzqApply: 'https://wzq.tenpay.com/mp/v1/apply/no_account.shtml',
    zxgIndex: 'qqstock://zixuan',
    zxgZSApply: 'qqstock://tradefunc/hsopenaccount',
  };
  
  const LABEL = [
		{
			title: '忧郁',
			content: '但凡是个敏感的成人 生来就有资格 郁郁寡欢',
			author: '菲茨杰拉德',
			imgUrl: require('../../images/label/1_upset.png'),
		},
		{
			title: '油腻',
			content: '真正成熟的人 总能找到 小时候玩游戏的 那种认真',
			author: '弗里德里希·尼采',
			imgUrl: require('../../images/label/2_greasy.png'),
			// imgUrl: '../../images/label/2_greasy.png',
		},
		{
			title: '躺赢',
			content: '如有巧合 别当巧合',
			author: '刘震云',
			imgUrl: require('../../images/label/3_win.png'),
		},
		{
			title: '剪不断',
			content: '生活比秩序重要 适度的混乱对生活 有益',
			author: '玛丽链·弗伦奇',
			imgUrl: require('../../images/label/4_cantcut.png'),
		},
		{
			title: '心诚则零',
			content: '我们的正常之处 就在于 懂得自己的不正常',
			author: '村上春树',
			imgUrl: require('../../images/label/5_believe.png'),
		},
		{
			title: '戏精',
			content: '要成长为新的物种 就要经历所有 你不会 再扮演的角色',
			author: '凯文·凯利',
			imgUrl: require('../../images/label/6_victor.png'),
		},
		{
			title: 'all in猛干',
			content: '冒险没有关系 但当承担风险时 不要赌上全部财产',
			author: '乔治·索罗斯',
			imgUrl: require('../../images/label/7_allin.png'),
		},
		{
			title: '小确丧',
			content: '年少时代的忧郁 是对整个宇宙的骄傲',
			author: '芥川龙之介',
			imgUrl: require('../../images/label/8_littlesad.png'),
		},
		{
			title: '淡定',
			content: '不要因为事与愿违 而感到惊讶 因为这个宇宙 比你大得多',
			author: '阿兰·德波顿',
			imgUrl: require('../../images/label/9_calmdown.png'),
		},
		{
			title: '主见',
			content: '不要盲目崇拜任何 权威 因为你总能找到 相反的权威',
			author: '伯特兰·罗素',
			imgUrl: require('../../images/label/10_opinion.png'),
		},
		{
			title: '洪荒之力',
			content: '当你想要 某种东西时 整个宇宙会合力 助你实现愿望',
			author: '保罗·柯艾略',
			imgUrl: require('../../images/label/11_strong.png'),
		},
		{
			title: '假装坚强',
			content: '生活就像海洋 只有意志坚强的人 才能到达彼岸。',
			author: '马克思',
			imgUrl: require('../../images/label/12_pretendstrong.png'),
		},
		{
			title: '猴赛雷',
			content: '活着的人 都是无敌的',
			author: '奥西普·曼德尔施塔姆',
			imgUrl: require('../../images/label/13_hou.png'),
		},
		{
			title: '佛系',
			content: '世道再难 也要顺畅呼吸',
			author: '舒国治',
			imgUrl: require('../../images/label/14_casual.png'),
		},
		{
			title: '价值',
			content: '尽管赚钱很好 但拥有 有意义的工作和 人际关系 要比赚钱 有价值的多',
			author: '瑞·达利欧',
			imgUrl: require('../../images/label/15_worthy.png'),
		},
		{
			title: '杠精',
			content: '世界让我遍体鳞伤 但伤口长出的 却是翅膀',
			author: '阿多尼斯',
			imgUrl: require('../../images/label/16_discussman.png'),
		},
		{
			title: '神操作',
			content: '想要在股市 从事波段操作 是神做的事 不是人做的事',
			author: '巴菲特',
			imgUrl: require('../../images/label/17_godoperate.png'),
		},
		{
			title: '积蓄',
			content: '你过去所做的 每一件事 都将成为 未来人生的伏笔',
			author: '许荣哲',
			imgUrl: require('../../images/label/18_saving.png'),
		},
		{
			title: '远足',
			content: '路不要紧 保持走要紧',
			author: '陈丹青',
			imgUrl: require('../../images/label/19_fartravel.png'),
		},
		{
			title: '宅',
			content: '只要有想见的人 就不再是孤身一人',
			author: '大森贵弘',
			imgUrl: require('../../images/label/20_home.png'),
		},
		{
			title: '沧桑',
			content: '昔日我如此苍老 如今才是风华正茂',
			author: '鲍勃·迪伦',
			imgUrl: require('../../images/label/21_old.png'),
		},
		{
			title: '通关',
			content: '有时候坚持了 你最不想干的事情 之后便可得到 你最想要的东西',
			author: '宫崎骏',
			imgUrl: require('../../images/label/22_cross.png'),
		},
		{
			title: '怂',
			content: '你没有走错路 你是在等待 风的到来',
			author: '伊吹有喜',
			imgUrl: require('../../images/label/23_followheart.png'),
		},
		{
			title: '傲娇',
			content: '像狮子一样高傲 像少女一样温柔',
			author: '奥诺雷·德·巴尔扎克',
			imgUrl: require('../../images/label/24_proud.png'),
		},
		{
			title: '傻白甜',
			content: '每个大人心里 都住着一个孩子 而每个小孩心里 都有个 未来成人在等候',
			author: '约翰·康诺利',
			imgUrl: require('../../images/label/25_sweet.png'),
		},
		{
			title: '原谅',
			content: '凡是过去皆为序章 爱所有人 信任少数人 不负任何人',
			author: '莎士比亚',
			imgUrl: require('../../images/label/26_forgive.png'),
		},
		{
			title: '逆袭',
			content: '做人要逆流而上 顺流而下只能找到 垃圾堆',
			author: '双雪涛',
			imgUrl: require('../../images/label/27_counterattact.png'),
		},
		{
			title: 'Q',
			content: '可爱 是最高级的形容词',
			author: '金子文纪',
			imgUrl: require('../../images/label/28_q.png'),
		},
		{
			title: '随性',
			content: '当我们不知道 应当去哪里时 真正的旅行 才刚刚开始',
			author: '纳齐姆·希克梅特',
			imgUrl: require('../../images/label/29_compliance.png'),
		},
		{
			title: '摸索',
			content: '没有人真正掌握 生活的艺术 每个人都只是在 黑暗中踉跄',
			author: '理查德·麦奎尔',
			imgUrl: require('../../images/label/30_search.png'),
		},
		{
			title: '守望',
			content: '在一定的距离之外 每个人都可能是 我们要找的那一个',
			author: '瓦莱里娅·路易塞利',
			imgUrl: require('../../images/label/31_protect.png'),
		},
		{
			title: '宠溺',
			content: '爱吃甜食的人 都有一颗柔软的心',
			author: '拜伦·霍华德',
			imgUrl: require('../../images/label/32_pamper.png'),
		},
		{
			title: '封印',
			content: '极限的思索 让人晓得 自己其实可以更好',
			author: '唐诺',
			imgUrl: require('../../images/label/33_fengyin.png'),
		},
		{
			title: '忐忑',
			content: '生命是什么呢 生命是 时时刻刻 不知如何是好',
			author: '木心',
			imgUrl: require('../../images/label/34_noisy.png'),
		},
		{
			title: '珍惜',
			content: '种一棵树 最好的时间是 十年前 而后是现在',
			author: '丹比萨·莫约',
			imgUrl: require('../../images/label/35_cherish.png'),
		},
		{
			title: '思念',
			content: '一个假期的 成功之处 就在于 它使你想回家了',
			author: '伊恩·麦克尤恩',
			imgUrl: require('../../images/label/36_miss.png'),
		},
		{
			title: '开挂',
			content: '站立着的心 只有努力努力 再努力',
			author: '张艺兴',
			imgUrl: require('../../images/label/37_kaigua.png'),
		},
		{
			title: '希望',
			content: '黑夜无论怎样悠长 白昼总会到来',
			author: '莎士比亚',
			imgUrl: require('../../images/label/38_hope.png'),
		},
	];
// let unloadList = [
//     require('../../images/label/3_win.png'),
//     require('../../images/label/4_cantcut.png'),
//     require('../../images/label/4_cantcut.png'),
//     require('../../images/label/4_cantcut.png'),
//     require('../../images/label/4_cantcut.png'),
//     require('../../images/label/4_cantcut.png'),
//     require('../../images/label/4_cantcut.png'),
//     require('../../images/label/4_cantcut.png'),
// ];
	const CanvasView: any = () => ({
		component: import('../../../../component-dev/canvas-view'),
		delay: 0,
		loading: {
			render(h: any) {
				return <div>{this.$slots.default}</div>;
			},
		} as any,
	});


  async function loadImage(imageUrl: any) {
    return (await getImage(imageUrl)).src;
  }

  // 增加扩展，是否要替换图片路径
  function getImage(imageUrl: any, replaceurl: boolean = true): any {
    return new Promise((resolve) => {
      let parsedImageUrl = imageUrl;
      if (replaceurl) {
          if (!/^data/.test(imageUrl) && /^https?/.test(imageUrl)) {
            parsedImageUrl = url.parse(imageUrl).path;
          }
      }

      const img = new Image();
      img.src = parsedImageUrl;
      img.onload = () => resolve(img);
    });
  }

  @Component({
    components: {
      Dialog,
      Button,
      CanvasView,
      QRCode
    },
    directives:{longTouch}
  })
  export default class Page extends Vue {
    @Prop(String)
    URL!: string;
    // 产生随机签
    label: any = sample(LABEL);
    showShareGuide: Boolean = false;
    scale =  2;
    dataURL: string = null;
    preloadPromise = Promise.resolve();
    ready = false;
    backgroundImage: string = null;
    bottomImage: string = null;
    qrImage: string = null;
    labelLeftImage: string = null;
    labelRightImage: string = null;
    labelTitleImage: string = null;
    labelKeywordImage: string = null;
    bgCard: string = null;
    bgSaveImg: string = null;
    nickname: string = localStorage.getItem('nickname');
    userInfo: any;
    $dialog: any;
    hasQRCode = false;
    url: any;
    rule_type: any;
    unloadList: any;
    
    get isZxg() {
      const query = qs.parse(location.search.substring(1));
      return IS_MQQ ||
        IS_ZXG ||
        this.$route.query.from === 'zxg' ||
        query.from === 'zxg' || query._from === 'zxg' || this.$route.query._from === 'zxg';
    }

    created() {
        // 加载签的关键词图片
        this.loadImg();
    }
    
    beforeMount() {
      let imageList = [
        require('../../images/label_title.png'), 
        this.label.imgUrl,
        require('../../images/share_qrcode.png'),
        require('../../images/share_label_left.png'),
        require('../../images/share_label_right.png'),
        require('../../images/bg_card_shadow.png'),
        require('../../images/bg_save_img01.png'),
      ];
      this.preloadPromise = Promise
        .all(imageList.map(loadImage))
        .then(([labelTitleImage, labelKeywordImage, qrImage, labelLeftImage, labelrightImage, bgCard, bgSaveImg]) => {
            this.labelTitleImage = labelTitleImage;
            this.labelKeywordImage = labelKeywordImage;
            this.qrImage = qrImage;
            this.labelLeftImage = labelLeftImage;
            this.labelRightImage = labelrightImage;
            this.bgCard = bgCard;
            this.bgSaveImg = bgSaveImg;
        });
      
      this.url = IS_ZXG ? 'https://wzq.tenpay.com/activity/page/190115newyear/#/land?_from=zxg' : 'https://wzq.tenpay.com/activity/page/190115newyear';
    }
    
    async mounted() {
      let self = this;
      try {
        const { data } = await activity.getUserInfo();
        this.userInfo = data;
      } catch (e) {
        // const { data = {} } = e;
        // this.$dialog.alert({
        //     content: '系统繁忙，请稍后重试',
        //     confirmBtn: '确定',
        // });
      }
    }

    loadImg() {
        this.unloadList = [
          this.label.imgUrl,
        ];
        if(this.unloadList.length > 0){
            let url =this. unloadList.pop();
            getImage(url, false).then(()=>{
                this.loadImg();
            });
        }
    }
    
    showShareGuidePopup() {
      // let $shareGuide = this.$refs.shareGuide as any;
      const currentPath = this.$route.path;
      if (IS_ZXG)  {
        this.shareZxg();
        stat.sendClickStat(
            makeStatReportParam('19newyear.label.goshare.click.zxg', currentPath),
            currentPath,
        );
      } else {
        stat.sendClickStat(
            makeStatReportParam('19newyear.label.goshare.click', currentPath),
            currentPath,
        );
        this.showShareGuide = true;
      }
    }

		async jumpToOtherPage() {
			const currentPath = this.$route.path;
			if (IS_ZXG) {
				const { data } = await activity.beforeGetReward();
				if (data.rule_type == 1) {
					stat.sendClickStat(
						makeStatReportParam('19newyear.index.btnlucky.choose.click.zxg', currentPath),
						currentPath,
					);
					location.href = links.zxgIndex;
				} else {
					stat.sendClickStat(
						makeStatReportParam('19newyear.index.btnlucky.apply.click.zxg', currentPath),
						currentPath,
					);
					location.href = links.zxgZSApply;
				}
			} else {
				const { data: userInfo } = await activity.getUserInfo();
				this.userInfo = userInfo;
				if (this.userInfo.userstate == '0' || this.userInfo.userstate == '3') {
					stat.sendClickStat(
						makeStatReportParam('19newyear.index.btnlucky.choose.click', currentPath),
						currentPath,
					);
                  location.replace(links.wzqIndex);
				} else {
					stat.sendClickStat(
						makeStatReportParam('19newyear.index.btnlucky.choose.click', currentPath),
						currentPath,
					);
                  location.replace(links.wzqApply);
				}
			}
		}

    onCanvasViewReady() {
      this.ready = true;
      this.preloadPromise.then(() => {
        return new Promise((resolve) => this.$nextTick(() => {
          this.generateImage().then(resolve);
        }))
      })
        .then((data: any) => {
          this.$nextTick(() => {
            this.dataURL = data;
          });
        });
    }

    shareZxg() {
        sdk.openShareView({
            platform: ['wx', 'pyq', 'qq', 'qzone'],
            type: 'image',
            image: this.dataURL,
        });
    }

    @autobind()
    async generateImage() {
      if (this.hasQRCode) {
        const canvas = await (this.$refs.view as any).toCanvasElement();
        const dataURL = canvas.toDataURL();
        const image = await getImage(dataURL);
        const context = canvas.getContext('2d');
        context.drawImage(image, 0, 0, image.width + 5, image.height + 5);
        return canvas.toDataURL();
      } else {
        return new Promise((resolve) => {
          this.$on('qrcode', () => resolve(this.generateImage()));
        });
      }
    }

    @Emit('qrcode')
    onQrcodeLoaded() {
        this.hasQRCode = true;
    }

    onClone(doc: Document) {
      doc.body.classList.add('canvas-view');
    }

    /**
     * 将空格转为换行
     */
    preprocessWishText(text: string) {
      return text.replace(/\s+/g, '<br>');
    }

    handleLongTouch() {
        const currentPath = this.$route.path;
			stat.sendClickStat(
				makeStatReportParam(`19newyear.label.shareimg.longtap${IS_ZXG ? '.zxg' : ''}`, currentPath),
				currentPath,
			);
    }
  }
